import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const inpStyle = { width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const card = { background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '24px 28px' };

export default function Perfil() {
  const { usuario } = useAuth();
  const [form, setForm] = useState({ senha_atual: '', nova_senha: '', confirmar_senha: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const setV = (campo, val) => setForm(f => ({ ...f, [campo]: val }));

  const salvar = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (form.nova_senha !== form.confirmar_senha) { setMsg({ tipo: 'erro', texto: 'As senhas não coincidem' }); return; }
    if (form.nova_senha.length < 6) { setMsg({ tipo: 'erro', texto: 'A nova senha deve ter pelo menos 6 caracteres' }); return; }
    setLoading(true);
    try {
      await api.put('/auth/senha', { senha_atual: form.senha_atual, nova_senha: form.nova_senha });
      setMsg({ tipo: 'ok', texto: 'Senha alterada com sucesso!' });
      setForm({ senha_atual: '', nova_senha: '', confirmar_senha: '' });
    } catch (err) {
      setMsg({ tipo: 'erro', texto: err.response?.data?.error || 'Erro ao alterar senha' });
    } finally { setLoading(false); }
  };

  const iniciais = usuario?.nome?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() || 'U';

  return (
    <div style={{ maxWidth: '500px' }}>
      <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533', marginBottom: '20px' }}>Meu perfil</div>

      {/* Info do usuário */}
      <div style={{ ...card, marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#1A3A5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: '700', color: '#fff', flexShrink: 0 }}>
          {iniciais}
        </div>
        <div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>{usuario?.nome}</div>
          <div style={{ fontSize: '13px', color: '#6B7A8D', marginTop: '2px' }}>{usuario?.email}</div>
          <div style={{ display: 'inline-block', marginTop: '6px', background: '#E6F1FB', color: '#185FA5', padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>
            {usuario?.nivel}
          </div>
        </div>
      </div>

      {/* Alterar senha */}
      <div style={card}>
        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '18px' }}>🔒 Alterar senha</div>

        {msg && (
          <div style={{ padding: '12px 14px', borderRadius: '8px', marginBottom: '16px', background: msg.tipo === 'ok' ? '#EAF5EE' : '#FDECEA', color: msg.tipo === 'ok' ? '#2D7D4F' : '#C0392B', fontSize: '13px', fontWeight: '500' }}>
            {msg.texto}
          </div>
        )}

        <form onSubmit={salvar}>
          <div style={{ marginBottom: '14px' }}>
            <label style={lbl}>Senha atual</label>
            <input type='password' value={form.senha_atual} onChange={e => setV('senha_atual', e.target.value)} style={inpStyle} placeholder='••••••••' required />
          </div>
          <div style={{ marginBottom: '14px' }}>
            <label style={lbl}>Nova senha</label>
            <input type='password' value={form.nova_senha} onChange={e => setV('nova_senha', e.target.value)} style={inpStyle} placeholder='Mínimo 6 caracteres' required />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={lbl}>Confirmar nova senha</label>
            <input type='password' value={form.confirmar_senha} onChange={e => setV('confirmar_senha', e.target.value)} style={inpStyle} placeholder='Repita a nova senha' required />
          </div>
          <button type='submit' disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
            {loading ? 'Alterando...' : 'Alterar senha'}
          </button>
        </form>
      </div>
    </div>
  );
}
